import { cliente } from './cliente';
import { Usuario } from './usuario';

export class CreateclienteDto extends cliente {
    public usuario !: Usuario;
 } 
